import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { MessageCircle, CheckCircle2, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-nova-navy-dark" data-id="element-115">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-116">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-nova-navy-light/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-117" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-nova-gold/5 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4" data-id="element-118" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-119">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-120">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-121">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-nova-navy-light/50 border border-nova-gold/30 text-nova-gold text-sm font-medium mb-6" data-id="element-122">
              <Star size={14} className="fill-nova-gold" data-id="element-123" />
              Agencia Especializada en Negocios Locales
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-124">
              Convierta las búsquedas de Google e Instagram en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-nova-gold to-nova-gold-light" data-id="element-125">
                clientes reales.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-126">
              Creamos su Conversion Lander profesional en 72 horas. Diseñada
              para posicionarse en su ciudad y cerrar ventas por WhatsApp de
              inmediato.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-127">
              <Button href="#contacto" className="text-lg w-full sm:w-auto px-8 py-4" data-id="element-128">
                Quiero mi Auditoría de Negocio Local Gratis
              </Button>
            </div>

            <div className="mt-8 flex items-center gap-4 text-sm text-gray-400" data-id="element-129">
              <div className="flex items-center gap-1.5" data-id="element-130">
                <CheckCircle2 size={16} className="text-nova-gold" data-id="element-131" />
                <span data-id="element-132">Diseño en 72 hrs</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-133">
                <CheckCircle2 size={16} className="text-nova-gold" data-id="element-134" />
                <span data-id="element-135">Sin contratos forzosos</span>
              </div>
            </div>
          </motion.div>

          {/* Visual/Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-[320px] lg:max-w-[380px]" data-id="element-136">
            {/* Floating Notifications */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 1
          }} className="absolute -right-6 top-12 z-20 bg-white rounded-xl p-3 shadow-xl flex items-center gap-3 w-64" data-id="element-137">
              <div className="bg-green-500 rounded-full p-2" data-id="element-138">
                <MessageCircle size={20} className="text-white" data-id="element-139" />
              </div>
              <div data-id="element-140">
                <p className="text-xs font-bold text-gray-900" data-id="element-141">
                  Nuevo mensaje de WhatsApp
                </p>
                <p className="text-xs text-gray-500" data-id="element-142">
                  "Hola, ¿tienen citas disponibles hoy?"
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 2.5
          }} className="absolute -left-8 top-32 z-20 bg-white rounded-xl p-3 shadow-xl flex items-center gap-3 w-64" data-id="element-143">
              <div className="bg-green-500 rounded-full p-2" data-id="element-144">
                <MessageCircle size={20} className="text-white" data-id="element-145" />
              </div>
              <div data-id="element-146">
                <p className="text-xs font-bold text-gray-900" data-id="element-147">
                  Nuevo mensaje de WhatsApp
                </p>
                <p className="text-xs text-gray-500" data-id="element-148">
                  "Vi su página en Google, me interesa..."
                </p>
              </div>
            </motion.div>

            {/* Phone Mockup */}
            <div className="relative rounded-[2.5rem] border-[8px] border-nova-navy-light bg-nova-navy shadow-2xl overflow-hidden aspect-[9/19]" data-id="element-149">
              {/* Notch */}
              <div className="absolute top-0 inset-x-0 h-6 bg-nova-navy-light rounded-b-3xl w-1/2 mx-auto z-10" data-id="element-150" />

              {/* Screen Content (Mock Landing Page) */}
              <div className="absolute inset-0 bg-white overflow-hidden flex flex-col pt-8" data-id="element-151">
                {/* Header */}
                <div className="px-4 py-3 flex justify-between items-center border-b border-gray-100" data-id="element-152">
                  <div className="w-24 h-4 bg-gray-200 rounded animate-pulse" data-id="element-153" />
                  <div className="w-6 h-6 bg-gray-200 rounded-full" data-id="element-154" />
                </div>

                {/* Hero */}
                <div className="px-4 py-6 text-center" data-id="element-155">
                  <div className="w-3/4 h-6 bg-gray-800 rounded mx-auto mb-3" data-id="element-156" />
                  <div className="w-1/2 h-6 bg-gray-800 rounded mx-auto mb-4" data-id="element-157" />
                  <div className="w-full h-3 bg-gray-300 rounded mx-auto mb-2" data-id="element-158" />
                  <div className="w-5/6 h-3 bg-gray-300 rounded mx-auto mb-6" data-id="element-159" />

                  <div className="w-full h-12 bg-nova-gold rounded-lg flex items-center justify-center gap-2 shadow-lg" data-id="element-160">
                    <MessageCircle size={18} className="text-nova-navy-dark" data-id="element-161" />
                    <span className="text-nova-navy-dark font-bold text-sm" data-id="element-162">
                      Agendar por WhatsApp
                    </span>
                  </div>
                </div>

                {/* Image placeholder */}
                <div className="px-4 pb-4" data-id="element-163">
                  <div className="w-full h-40 bg-gray-100 rounded-xl overflow-hidden relative" data-id="element-164">
                    <div className="absolute inset-0 bg-gradient-to-tr from-gray-200 to-gray-100" data-id="element-165" />
                  </div>
                </div>

                {/* Services */}
                <div className="px-4 py-4 bg-gray-50 flex-1" data-id="element-166">
                  <div className="w-1/3 h-4 bg-gray-800 rounded mb-4" data-id="element-167" />
                  <div className="space-y-3" data-id="element-168">
                    {[1, 2, 3].map(i => <div key={i} className="flex gap-3 items-center bg-white p-3 rounded-lg shadow-sm" data-id="element-169">
                        <div className="w-10 h-10 bg-nova-navy-light/10 rounded-lg" data-id="element-170" />
                        <div className="flex-1" data-id="element-171">
                          <div className="w-2/3 h-3 bg-gray-800 rounded mb-2" data-id="element-172" />
                          <div className="w-full h-2 bg-gray-300 rounded" data-id="element-173" />
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>

            {/* Glow effect behind phone */}
            <div className="absolute inset-0 bg-nova-gold/20 blur-[100px] -z-10 rounded-full" data-id="element-174" />
          </motion.div>
        </div>
      </div>
    </section>;
}